var $ = require('jquery');
'use strict';

var PLUGIN_NAME = 'profileDialog';

var	DEFAULTS = {
	fieldsetSelector: null
};

var ProfileDialog = function (selector, options) {
	this.$t = $(selector);
	this.options = $.extend(true, {}, DEFAULTS, options );
	this._defaults = DEFAULTS;
	this.initialise_();
};

ProfileDialog.prototype.initialise_ = function() {
	this.requestedFieldsetId = this.getRequestedFieldsetId_();
	if (this.requestedFieldsetId == '#_=_') {
		this.requestedFieldsetId = '#fsChildren';
	}
	if (this.requestedFieldsetId && this.options.fieldsetSelector) {
		this.removeAllFieldsets_();
		this.enableRequestedFieldset_();
	} else {
		this.showAllFieldsets_();
	}
};

ProfileDialog.prototype.getRequestedFieldsetId_ = function() {
	return window.location.hash.indexOf('#') == 0 ? window.location.hash : null;
};

ProfileDialog.prototype.removeAllFieldsets_ = function() {
	$(this.options.fieldsetSelector, this.$t).hide();
};

ProfileDialog.prototype.showAllFieldsets_ = function() {
	$(this.options.fieldsetSelector, this.$t).show();
};

ProfileDialog.prototype.enableRequestedFieldset_ = function() {
	$(this.requestedFieldsetId).show();
};

/**
 * decide, which methods will be "public"
 */
var API = {};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 * 		if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new ProfileDialog(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.profile-dialog-form.js